module.exports = __webpack_public_path__ + "static/img_1284-6e6f646dbd3ee6d883945123dd7699e9.webp";